import { LocalizationHelper } from '../../helpers/localization/localization.helper';

type Keys =
  | 'title'
  | 'beta'
  | 'info'
  | 'greeting'
  | 'question'
  | 'placeholder'
  | 'loading'
  | 'loading2'
  | 'loading3'
  | 'downloadAvaliable'
  | 'speechRecognitionUnavailable'
  | 'aiAssistantError'
  | 'backendError'
  | 'downloadExpired';
const t = LocalizationHelper<Keys>('aiAssistant');

export const aiAssistantDe = t({
  title: 'WawiMate',
  greeting: 'Ihr KI-gestützter Assistent',
  placeholder: 'Hallo! Wie kann ich Ihnen helfen?',
  loading: 'Denke nach...',
  loading2: 'Wir bereiten die Daten für Sie vor...',
  loading3: 'Vielen Dank für Ihre Geduld...',
  downloadAvaliable: 'Download verfügbar für:',
  speechRecognitionUnavailable:
    'Ihr Browser unterstützt möglicherweise keine Spracherkennung. Bitte geben Sie Ihre Frage unten in das Eingabefeld ein.',
  aiAssistantError:
    'Entschuldigung, ich bin nicht schlau genug, um deine Frage zu verstehen 😊 Bitte füge mehr Details hinzu und versuche es erneut.',
  backendError:
    'Entschuldigung, es ist ein Fehler aufgetreten 😔 Bitte versuchen Sie es später erneut.',
  downloadExpired: 'Download abgelaufen',
  question: 'Ihre Frage',
  info: 'Dieses Werkzeug befindet sich derzeit in fortlaufender Entwicklung.',
  beta: 'Beta',
});

export const aiAssistantEn = t({
  title: 'WawiMate',
  greeting: 'Your AI-powered assistant',
  placeholder: 'Hello! How can I help you?',
  loading: 'Thinking...',
  loading2: 'We are preparing the data for you...',
  loading3: 'Thank you for your patience...',
  downloadAvaliable: 'Download available to:',
  speechRecognitionUnavailable:
    'Your browser may not support speech recognition. Please try typing your question in the input field below.',
  aiAssistantError:
    'Sorry, I’m not smart enough to understand your question 😊 Please add more details and try again.',
  backendError: 'Sorry, something went wrong 😔 Please try again later.',
  downloadExpired: 'Download expired',
  question: 'Your question',
  info: 'This tool is currently under ongoing development.',
  beta: 'Beta',
});

export const aiAssistantFr = t({
  title: 'WawiMate',
  greeting: 'Votre assistant propulsé par l’IA',
  placeholder: 'Bonjour ! Comment puis-je vous aider ?',
  loading: 'Réflexion en cours...',
  loading2: 'Nous préparons les données pour vous...',
  loading3: 'Merci pour votre patience...',
  downloadAvaliable: 'Téléchargement disponible pour :',
  speechRecognitionUnavailable:
    'Votre navigateur ne prend peut-être pas en charge la reconnaissance vocale. Veuillez saisir votre question dans le champ ci-dessous.',
  aiAssistantError:
    'Désolé, je ne suis pas assez intelligent pour comprendre votre question 😊 Veuillez ajouter plus de détails et réessayer.',
  backendError: 'Désolé, une erreur s’est produite 😔 Veuillez réessayer plus tard.',
  downloadExpired: 'Téléchargement expiré',
  question: 'Votre question',
  info: 'Cet outil est actuellement en cours de développement.',
  beta: 'Beta',
});

export const aiAssistantIt = t({
  title: 'WawiMate',
  greeting: 'Il tuo assistente potenziato dall’IA',
  placeholder: 'Ciao! Come posso aiutarti?',
  loading: 'Sto pensando...',
  loading2: 'Stiamo preparando i dati per te...',
  loading3: 'Grazie per la vostra pazienza...',
  downloadAvaliable: 'Download disponibile per:',
  speechRecognitionUnavailable:
    'Il tuo browser potrebbe non supportare il riconoscimento vocale. Prova a scrivere la tua domanda nel campo di input qui sotto.',
  aiAssistantError:
    'Mi dispiace, non sono abbastanza intelligente per capire la tua domanda 😊 Aggiungi più dettagli e riprova.',
  backendError: 'Mi dispiace, si è verificato un errore 😔 Riprova più tardi.',
  downloadExpired: 'Download scaduto',
  question: 'La tua domanda',
  info: 'Questo strumento è attualmente in fase di sviluppo continuo.',
  beta: 'Beta',
});
